/* clemoa "5 sebep" açılış sayfası: renk örneği → varyant bağlantısı + büyük görsel, galeri küçük resimleri,
   yapışkan çubuğun paket butonu görünürken gizlenmesi. Yalnız [data-c5-offer] / [data-c5-sticky] olan sayfalarda iş yapar. */
(function () {
  if (window.__clemoaLp) return;
  window.__clemoaLp = true;

  function anaGorsel(kutu, src, srcset, alt) {
    var img = kutu.querySelector('[data-c5-main] img');
    if (!img || !src) return;
    img.removeAttribute('loading');
    img.src = src;
    if (srcset) img.srcset = srcset;
    img.alt = alt || '';
  }

  function teklif(kutu) {
    if (kutu.dataset.c5Ready) return;
    kutu.dataset.c5Ready = '1';
    var etiket = kutu.querySelector('[data-c5-color]');
    var ornekler = kutu.querySelectorAll('[data-c5-swatch]');
    Array.prototype.forEach.call(ornekler, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(ornekler, function (x) { x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
        if (etiket) etiket.textContent = b.dataset.name || '';
        anaGorsel(kutu, b.dataset.src, b.dataset.srcset, b.dataset.alt);
        if (b.dataset.href) {
          Array.prototype.forEach.call(document.querySelectorAll('[data-c5-buy]'), function (a) { a.href = b.dataset.href; });
        }
      });
    });
    Array.prototype.forEach.call(kutu.querySelectorAll('[data-c5-thumb]'), function (t) {
      t.addEventListener('click', function () {
        anaGorsel(kutu, t.dataset.src, t.dataset.srcset, t.dataset.alt);
        var ana = kutu.querySelector('[data-c5-main]');
        if (ana && ana.getBoundingClientRect().top < 0) ana.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function cubuk() {
    var bar = document.querySelector('[data-c5-sticky]');
    var hedef = document.querySelector('[data-c5-offer] [data-c5-buy]');
    if (!bar || !hedef || bar.dataset.c5Ready || !('IntersectionObserver' in window)) return;
    bar.dataset.c5Ready = '1';
    new IntersectionObserver(function (girdi) {
      bar.classList.toggle('is-hidden', girdi[0].isIntersecting);
    }).observe(hedef);
  }

  function init(kok) {
    Array.prototype.forEach.call((kok || document).querySelectorAll('[data-c5-offer]'), teklif);
    cubuk();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
